// extracted by mini-css-extract-plugin
module.exports = {"root":"Number_root__jg6lW"};